<template>
    <div class="common-layout">
        <el-container>
            <el-aside width="collapse">

                <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
                         :collapse="isCollapse"
                         background-color="#545c64"
                         text-color="whitesmoke"
                         active-text-color="#ffd04b"
                         router>
                    <el-menu-item>
                        <el-icon size="25">
                            <HomeFilled/>
                        </el-icon>
                        <span slot="title" class="logo">优尚后台管理系统</span>
                    </el-menu-item>
                    <el-menu-item index="/pages/statistics/statisticsList">
                        <el-icon>
                            <DataAnalysis/>
                        </el-icon>
                        <span>仪表盘</span>
                    </el-menu-item>

                    <el-menu-item index="/pages/program">
                        <el-icon>
                            <Setting/>
                        </el-icon>
                        <span>系统配置</span>
                    </el-menu-item>

                    <el-menu-item index="/pages/invite">
                        <el-icon>
                            <Setting/>
                        </el-icon>
                        <span>邀请规则</span>
                    </el-menu-item>

                    <el-menu-item index="/pages/share/shareConfig">
                        <el-icon>
                            <Share/>
                        </el-icon>
                        <span slot="title">分享设置</span>
                    </el-menu-item>

                    <el-menu-item index="/pages/messagePush">
                        <el-icon>
                            <Message/>
                        </el-icon>
                        <span slot="title">消息推送</span>
                    </el-menu-item>

                    <el-menu-item index="/pages/menu">
                        <el-icon>
                            <Menu/>
                        </el-icon>
                        <span slot="title">菜单设置</span>
                    </el-menu-item>

                    <el-sub-menu index="/pages/video/Video">
                        <template #title>
                            <el-icon>
                                <VideoCamera/>
                            </el-icon>
                            <span>视频管理</span>
                        </template>
                        <el-menu-item index="/pages/video/VideoList">
                            <el-icon>
                                <Tickets/>
                            </el-icon>
                            <span>提取记录</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-menu-item index="/pages/advise/adviseList">
                        <el-icon>
                            <Message/>
                        </el-icon>
                        <span slot="title">建议管理</span>
                    </el-menu-item>
                    <el-menu-item index="/pages/order/orderList">
                        <el-icon>
                            <Money/>
                        </el-icon>
                        <span slot="title">订单管理</span>
                    </el-menu-item>
                    <el-menu-item index="/pages/member/memberList">
                        <el-icon>
                            <Money/>
                        </el-icon>
                        <span slot="title">会员管理</span>
                    </el-menu-item>

                    <el-menu-item index="/pages/share/shareList">
                        <el-icon>
                            <View/>
                        </el-icon>
                        <span slot="title">链接审核</span>
                    </el-menu-item>

                    <el-menu-item index="/pages/config/configList">
                        <el-icon>
                            <Setting/>
                        </el-icon>
                        <span slot="title">配置管理</span>
                    </el-menu-item>

                    <el-menu-item index="/pages/cookieConfig/cookieConfigList">
                        <el-icon>
                            <Setting/>
                        </el-icon>
                        <span slot="title">Cookie管理</span>
                    </el-menu-item>


                    <el-sub-menu index="/pages/user/user">
                        <template #title>
                            <el-icon>
                                <User/>
                            </el-icon>
                            <span>用户管理</span>
                        </template>
                        <el-menu-item index="/pages/user/userList">
                            <el-icon>
                                <Tickets/>
                            </el-icon>
                            <span>用户列表</span>
                        </el-menu-item>

                    </el-sub-menu>

                </el-menu>
            </el-aside>
            <el-container>
                <el-header>
                    <div>
                        <div class="changeMenuBtn">
                            <div v-if="isCollapse" @click="closeMenu()">
                                <el-icon size="25">
                                    <Expand/>
                                </el-icon>
                            </div>
                            <div v-if="!isCollapse" @click="openMenu()">
                                <el-icon size="25">
                                    <Fold/>
                                </el-icon>
                            </div>
                        </div>
                    </div>
                </el-header>
                <el-main class="custom_main">
                    <RightContent></RightContent>
                </el-main>
            </el-container>
        </el-container>
    </div>

</template>

<script>
    import RightContent from "./RightContent";

    export default {
        components: {
            RightContent
        },
        name: "BasePage",
        data() {
            return {
                isCollapse: false
            }
        },
        mounted() {

        },
        methods: {
            closeMenu() {
                this.isCollapse = false;
            },
            openMenu() {
                this.isCollapse = true;
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            }
        }
    }
</script>

<style lang="less" scoped>


    .logo {
        font-weight: 600;
        font-size: large;
        color: white;

    }

    .changeMenuBtn {
        display: flex;
        justify-content: left;
        align-items: center;
        height: 80px;
    }

    .el-menu-item.is-active {
        background-color: white !important;
        border-left: #1da232 solid 5px;
        color: #2c3e50;
    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        /*width: 200px;*/
        /*min-height: 400px;*/
    }

    .el-header, .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-aside {
        background-color: #545c64;
        color: #333;
        text-align: center;
        line-height: 200px;
        min-height: 100vh;
    }

    .el-main {
        padding: 10px;
        margin: 0;
        color: #333;
        background: #efefef;
    }

    body > .el-container {
        margin-bottom: 40px;
    }

    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
        line-height: 260px;
    }

    .el-container:nth-child(7) .el-aside {
        line-height: 320px;
    }


</style>
